import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import HomePage from "./pages/HomePage";
import About from "./pages/about";
import Contact from "./pages/contact";
import Service from "./pages/services";
import Companies from "./pages/Companies";
import LoginPage from "./pages/login";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import OnlineExam from "./pages/OnlineExam";
import TermsConditions from "./pages/TermsCondition";
import ShippingPolicy from "./pages/ShippingPolicy";
import CancellationPolicy from "./pages/CancellationPolicy";  

import AdminHome from "./components/admin/admin/Home";
import ExamResult from "./components/admin/admin/ExamResult";
import GetResult from "./components/admin/admin/GetResult";
import Questions from "./components/admin/admin/Questions";
import AdminLayout from "./components/admin/layout/AdminLayout";
import HomeSettings from "./components/admin/admin/HomeSettings";
import AboutSections from "./components/admin/admin/AboutSections";
import ServiceSections from "./components/admin/admin/ServiceSections";
import ContactSections from "./components/admin/admin/ContactSections";
import Portfolio from "./components/admin/admin/Portfolio";
import Clients from "./components/admin/admin/OurClients";
import Specialization from "./components/admin/admin/Specialization";
import DashboardSettings from "./components/admin/admin/DashboardSettings";
import CancelationPolicy from "./components/admin/admin/CancelationPolicy"; 
import TermsAndConditions from "./components/admin/admin/TermsConditions";
import ShippingPolicyAdmin from "./components/admin/admin/ShippingPolicy";
import GalleryAdmin from "./components/admin/admin/Gallery";
import Gallery from "./pages/Gallery";

import "./App.css";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAdminLoggedIn") === "true";
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/service" element={<Service />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/onlineexam" element={<OnlineExam />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/shipping" element={<ShippingPolicy />} />
        <Route path="/cancellation" element={<CancellationPolicy />} /> 

        {/* Protected Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminHome />} />
          <Route path="homesettings" element={<HomeSettings />} />
          <Route path="aboutsections" element={<AboutSections />} />
          <Route path="servicesections" element={<ServiceSections />} />
          <Route path="contactsections" element={<ContactSections />} />
          <Route path="portfolios" element={<Portfolio />} />
          <Route path="clients" element={<Clients />} />
          <Route path="specialization" element={<Specialization />} />
          <Route path="examresult" element={<ExamResult />} />
          <Route path="getresult" element={<GetResult />} />
          <Route path="questions" element={<Questions />} />
          <Route path="dashboardsettings" element={<DashboardSettings />} />
          <Route path="cancellationpolicy" element={<CancelationPolicy/>} />
          <Route path="termsconditions" element={<TermsAndConditions />} />
          <Route path="shippingpolicy" element={<ShippingPolicyAdmin />} />
          <Route path="gallery" element={<GalleryAdmin />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;